// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"9fd57267","225":"54384193","285":"83d2e943","289":"d007a769","315":"1b19a68b","421":"e739b38a","444":"07d71dc3","459":"89b19dec","787":"23e9becf","803":"9a84ab20","805":"74bcadda","852":"be0df34c","912":"affc9bbe","985":"16968a1f"}[chunkId] + ".chunk.js";
};